import { render, staticRenderFns } from "./linkpay.vue?vue&type=template&id=76f168ae&scoped=true&"
import script from "./linkpay.vue?vue&type=script&lang=js&"
export * from "./linkpay.vue?vue&type=script&lang=js&"
import style0 from "./linkpay.vue?vue&type=style&index=0&id=76f168ae&scoped=true&lang=css&"
import style1 from "./linkpay.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f168ae",
  null
  
)

export default component.exports